import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  HStack,
  Heading,
  Box,
  Image,
  Button,
  VStack,
} from '@chakra-ui/react';
import Select from 'react-select';
import { Controller, useForm } from 'react-hook-form';

import ConditionalNodeIcon from '../../../../assets/projects/conditional_node.svg';
import { ConditionalNodeData } from '../../models';
import { ConditionFieldDate } from '.';
import { FormFieldTypes, Form } from '../../../../models';

export const ConditionalNodeEditorModal = ({
  isOpen,
  onClose,
  form,
  conditionField,
}: {
  isOpen: boolean;
  onClose: (data?: ConditionalNodeData) => void;
  form: Form;
  conditionField: ConditionalNodeData['conditionField'];
}) => {
  const { handleSubmit, control, register, watch, setValue } =
    useForm<ConditionalNodeData>({
      defaultValues: {
        conditionField,
      },
    });

  const formTemplateOptions = form?.fields
    .filter(({ type }) => type !== FormFieldTypes.separator)
    .map(({ title, id }) => ({
      conditionFieldId: Number(id),
      title: title,
    }));

  const conditionFieldData = form?.fields.find(
    field => field.title === conditionField?.title
  );

  const onSubmit = (data: ConditionalNodeData) => {
    onClose({ ...data, form });
  };

  return (
    <Modal
      blockScrollOnMount={false}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      isCentered
    >
      <ModalOverlay />

      <ModalContent pb="4" borderRadius="md">
        <ModalHeader bg="custom_gray.5" borderTopRadius="md">
          <HStack>
            <Image src={ConditionalNodeIcon} />
            <Heading fontSize="md" fontWeight="medium" color="white">
              Conditions and Statements{' '}
              {conditionFieldData &&
                `Based on ${String(conditionFieldData.title)}`}
            </Heading>
          </HStack>
          <ModalCloseButton color="white" />
        </ModalHeader>
        <ModalBody>
          <VStack
            as="form"
            align="stretch"
            gap="2"
            onSubmit={handleSubmit(onSubmit)}
          >
            {!conditionFieldData ? (
              <Box>
                <Controller
                  control={control}
                  name="conditionField"
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={formTemplateOptions}
                      getOptionValue={({ title }) => String(title)}
                      getOptionLabel={({ title }) => (
                        <Box
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                          ml="1.5"
                          maxW="40"
                        >
                          {title}
                        </Box>
                      )}
                    />
                  )}
                />
              </Box>
            ) : (
              <ConditionFieldDate
                register={register}
                watch={watch}
                control={control}
                setValue={setValue}
                conditionField={conditionFieldData}
              />
            )}

            <HStack>
              <Button
                bg="custom_orange.2"
                _hover={{ bg: 'custom_orange.2' }}
                color="white"
                w="full"
                type="submit"
              >
                Save
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
